export const FONT_HELVETICA: string = "helvetica";
export const FONT_RIFFICFREE_BOLD_36: string = "RifficFree-Bold";

// Change this to be which ever font you want as default
export const FONT_DEFAULT: string = FONT_HELVETICA;

export const TWEEN_ONCOMPLETE: string = "onComplete";
export const TWEEN_ONUPDATE: string = "onUpdate";

export const DEBUG_MINIMAL_AUDIO: boolean = false;
export const DEBUG_SKIP_LOAD: boolean = false;
export const DEBUG_DEFAULT_STATE: string | undefined = undefined;

export const DWELL_DURATION: number = 1.7;

export const SFX_VOLUME_MAX = 0.15;
export const BGM_VOLUME_MAX = 0.075;
export const VO_VOLUME_MAX = 0.75;

export const BUTTON_SIZE_MIN = 1;
export const BUTTON_SIZE_MAX = 1.2;
